export const ANIMALS = [
    "Spira",
    "Savane",
    "Balthazar",
    "Choco",
    "Alpi",
    "Baloo",
    "Simba",
    "Blacky",
    "Nala",
    "Pixel",
    "Chameau",
    "Harissa",
    "Caramel",
    "Nougat",
];